import processPlayerStatsBasketball from "../../../common/processPlayerStats.basketball.ts";
import type { StatSumsExtra } from "../../../common/processPlayerStats.basketball.ts";
import type { PlayerStats, PlayerStatType } from "../../../common/types.ts";

const processPlayerStats = (
	ps: PlayerStats,
	stats: string[],
	statType?: PlayerStatType,
	bornYear?: number,
	keepWithNoStats?: boolean,
	statSumsExtra?: StatSumsExtra,
) => {
	return processPlayerStatsBasketball(
		ps,
		stats,
		statType,
		bornYear,
		keepWithNoStats,
		statSumsExtra,
	);
};

export default processPlayerStats;
